import { useState, useEffect } from "react";
import { chartGrid, chartLabel, useThemeMode } from "../../contexts/theme-mode";
import { Bar } from "react-chartjs-2";
import "./bar2.style.scss";

const defaultOptions = {
  responsive: true,
  maintainAspectRatio: false,
  borderRadius: 2,
  plugins: {
    datalabels: {
      display: false,
    },
    legend: {
      display: false,
    },
  },
  indexAxis: "y",
};

export default function Bar2({ value, onClick }) {
  const { mode } = useThemeMode();
  const [data, setData] = useState({ datasets: [] });
  const [options, setOptions] = useState(defaultOptions);
  const [delayed, setDelayed] = useState(false);

  useEffect(() => {
    const labels = [];
    const values = [];

    (value || []).forEach((item) => {
      labels.push(item.product_name || "");
      values.push(Number(item.container_used) || 0);
    });

    setData({
      labels,
      datasets: [
        {
          barPercentage: 1.11,
          categorySpacing: 0,
          data: values,
          backgroundColor: "#8b4e3f",
        },
      ],
    });
  }, [value]);

  useEffect(() => {
    const labelColor = chartLabel(mode);
    setOptions({
      ...defaultOptions,
      color: labelColor,
      scales: {
        y: {
          grid: {
            display: false,
          },
          ticks: {
            color: labelColor,
            callback: function (tickValue) {
              const label = this.getLabelForValue(tickValue);
              if (!label) return "";
              return label.length > 18 ? `${label.slice(0, 18)}…` : label;
            },
          },
        },
        x: {
          ticks: {
            stepSize: 2,
            color: labelColor,
          },
          grid: {
            color: chartGrid(mode),
          },
        },
      },
      animation: {
        onComplete: () => {
          setDelayed(true);
        },
        delay: (context) => {
          let delay = 0;
          if (
            context.type === "data" &&
            context.mode === "default" &&
            !delayed
          ) {
            delay = context.dataIndex * 150 + context.datasetIndex * 100;
          }
          return delay;
        },
      },
    });
  }, [mode]);

  return (
    <div className="bar2-body" onClick={onClick}>
      <div className="bar2-container">
        <Bar data={data} options={options} onElementsClick={onClick} />
      </div>
    </div>
  );
}
